module.exports = __webpack_public_path__ + "img/d73bdc2.jpg";